import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/patron/checkins/distinct/{currentPage}/{pageSize}'
const method = 'get'

interface UseGetPatronListByLeCheckinsParams {
  paginationModel: any
  currentPage: number
  pageSize: number
  licensedEstablishmentId: number | undefined
  startDate: Date
  endDate: Date
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetPatronListByLeCheckins = ({
  paginationModel,
  currentPage,
  pageSize,
  licensedEstablishmentId,
  startDate,
  endDate,
}: UseGetPatronListByLeCheckinsParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      path,
      paginationModel,
      licensedEstablishmentId,
      startDate,
      endDate,
    ],
    queryArgs: {
      currentPage,
      pageSize,
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  })
